import { cva, type VariantProps } from "class-variance-authority";
import { createElement, type HTMLAttributes, type Ref } from "react";

import { cn } from "../utils";

const textVariants = cva("last:mb-0", {
  variants: {
    htmlTag: {
      div: "",
      span: "",
      p: "m-0",
      dl: "",
      dt: "",
      dd: "",
      label: "",
    },
  },
});

export interface ITextProps
  extends HTMLAttributes<HTMLElement>,
    VariantProps<typeof textVariants> {
  htmlFor?: string;
}

export const Text = ({
  children,
  className,
  htmlTag = "div",
  ref,
  ...rest
}: ITextProps & {
  ref?: Ref<HTMLElement>;
}) => {
  return createElement(
    htmlTag ?? "div",
    {
      className: cn(textVariants({ htmlTag }), className),
      ref,
      ...rest,
    },
    children,
  );
};
